export type CameraListItem = Camera & {
  device_id: string
  device_name: string
}

export type CameraError = {
  message?: string
  timestamp?: string
}

export type Camera = {
  camera_id: string
  source: CameraSource
  camera_name: string
  image: string
  thumbnail: string
  connected: boolean
  error?: CameraError
  stream_type: 'rtsp' | 'usb'
  fps: number
  resolution:
    | {
        width: number
        height: number
      }
    | string // TODO we still support old string format h x w for backward compatibility
  attributes?: MilestoneCameraAttributes
  last_screenshot_time?: string
  last_ping_time?: string
}

export type MilestoneCameraAttributes = {
  milestone_camera_id: string
  milestone_stream_ids: string[]
}

export enum CameraSource {
  Visionplatform = 'visionplatform',
  Milestone = 'milestone'
}

export type CameraCreationStatusData = {
  status: CameraCreationStatus
  total_tasks: number
  completed_tasks: number
  failed_tasks: number
  failed_rtsp_urls: string[]
}

export type CameraCreationStatus = 'Pending' | 'Complete' | 'Failed'

export type ImportCameraData = {
  id: string
  name: string
  rtsp: {
    id: string
    url: string
    image: string | null
    thumbnail: string | null
  }
}

// TODO: legacy type that will be removed after the new cameras API is finalized
export type CameraStreamWithDeviceId = Camera & {
  device_id: string
  device_name: string
  is_device_active: boolean
}
